import { useServicesChartsDataContext } from '../../../hooks/useServicesChartsDataContext';
import { years } from '../../../../Filters/Filters';
import { useMemo } from 'react';

const useServicesPerYearTotalChart = () => {
    const { chartData, subtitles } = useServicesChartsDataContext();

    const series = useMemo(
        () =>
            subtitles.map((item) => {
                const data = years.map((year) => {
                    const found = chartData.counterYear.find(
                        (counter) =>
                            (counter.description ?? '-') === item &&
                            counter.ano_competencia === year
                    );

                    return found ? Number(found.services) : 0;
                });

                return {
                    name: item,
                    data
                };
            }),
        [chartData, subtitles]
    );

    return { series };
};

export default useServicesPerYearTotalChart;
